import { currencySymbol } from "../../utils/currencyUtils";
import { useEffect } from "react";

export default function CooperateModal({
  lang, darkMode, user, userProfile,
  cooperateModal, setCooperateModal,
  cooperateAmount, setCooperateAmount,
  cooperatePayError, setCooperatePayError,
  cooperateGift, showToast,
}) {
  const g = cooperateModal.gift;
  const owner = cooperateModal.ownerMember;
  const giftCurrency = g.currency || "USD";
  const giftSym = currencySymbol(giftCurrency);
  const totalCooped = (g.cooperations || []).reduce(function(acc, c) { return acc + (parseFloat(c.amount) || 0); }, 0);
  const goalPrice = parseFloat(g.price) || 0;
  const pct = goalPrice > 0 ? Math.min(100, (totalCooped / goalPrice) * 100) : 0;
  const myCooperation = (g.cooperations || []).find(function(c) { return c.uid === user?.uid; });
  const hasMp = owner?.mercadopago;
  const hasPp = owner?.paypal;
  useEffect(function() {
  setCooperateAmount("");
}, [setCooperateAmount]);


  const doCooperate = function() {
  const val = parseFloat(cooperateAmount);
  if (!cooperateAmount || isNaN(val) || val <= 0) {
    close();
    return;
  }
  cooperateGift(cooperateModal.wishlistId, g.id, cooperateAmount, null);
  setCooperateModal(null);
  setCooperateAmount("");
  setCooperatePayError(false);
};

  const close = function() {
    setCooperateModal(null);
    setCooperateAmount("");
    setCooperatePayError(false);
  };

  return (
    <div className="modal-overlay" onClick={function(e) { if (e.target === e.currentTarget) close(); }}>
      <div className="modal">
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6 }}>
          <svg width="38" height="38" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="8" y="52" width="62" height="44" rx="5" fill="#8e44ad" stroke="#6c3483" strokeWidth="3"/>
            <rect x="4" y="40" width="70" height="16" rx="4" fill="#9b59b6" stroke="#6c3483" strokeWidth="3"/>
            <rect x="33" y="40" width="10" height="56" fill="#d4a853"/>
            <rect x="4" y="47" width="70" height="8" fill="#d4a853"/>
            <path d="M38 40 C26 24 4 22 12 36 C17 46 34 44 38 40Z" fill="#d4a853"/>
            <path d="M38 40 C50 24 72 22 64 36 C59 46 42 44 38 40Z" fill="#d4a853"/>
            <circle cx="76" cy="30" r="22" fill="#FFD93D" stroke="#C8A000" strokeWidth="3"/>
            <circle cx="76" cy="30" r="15" fill="#FFC200" stroke="#C8A000" strokeWidth="2"/>
            <text x="76" y="37" textAnchor="middle" fill="#7A5800" fontSize="17" fontWeight="900" fontFamily="Arial, sans-serif">$</text>
          </svg>
          <h3 style={{ fontFamily: "Playfair Display, serif", fontSize: 18, margin: 0 }}>
            {lang === "es" ? "Cooperar" : lang === "fi" ? "Osallistua" : "Contribute"}
          </h3>
        </div>
        <p style={{ fontSize: 13, color: "#999", marginBottom: 16 }}>{g.name}</p>

        {goalPrice > 0 && (
          <div style={{ marginBottom: 18 }}>
            <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, color: "#999", marginBottom: 6 }}>
              <span>{lang === "es" ? "Reunido" : "Collected"}: <strong style={{ color: "#27ae60" }}>{giftSym}{totalCooped.toFixed(0)}</strong></span>
              <span>{lang === "es" ? "Meta" : "Goal"}: <strong>{giftSym}{goalPrice.toFixed(0)}</strong></span>
            </div>
            <div style={{ height: 8, background: darkMode ? "#2e2e2e" : "#f0ece6", borderRadius: 8, overflow: "hidden" }}>
              <div style={{ height: "100%", width: pct + "%", background: pct >= 100 ? "#27ae60" : "#d4a853", borderRadius: 8, transition: "width 0.4s" }} />
            </div>
            {(g.cooperations || []).length > 0 && (
              <div style={{ marginTop: 10, fontSize: 11, color: "#aaa" }}>
                {(g.cooperations || []).map(function(c) {
                  return (
                    <div key={c.uid} style={{ display: "flex", justifyContent: "space-between", padding: "3px 0" }}>
                      <span>{c.uid === user?.uid ? (lang === "es" ? "Tú" : "You") : c.name}</span>
                      <span style={{ color: "#27ae60", fontWeight: 600 }}>{giftSym}{parseFloat(c.amount).toFixed(0)}</span>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

        <div className="campo">
          <label className="campo-label">
            {lang === "es" ? "¿Cuánto vas a enviar?" : "How much will you send?"}
            {" "}({giftSym} {giftCurrency}{giftCurrency !== (userProfile?.currency || "USD") ? " — " + (lang === "es" ? "moneda del regalo" : "gift's currency") : ""})
          </label>
          <input className="campo-input" inputMode="decimal" placeholder="0.00" value={cooperateAmount} autoFocus
            onChange={function(e) { setCooperateAmount(e.target.value.replace(/[^0-9.]/g, "")); }} />
          {myCooperation && (
            <div style={{ fontSize: 11, color: "#d4a853", marginTop: 4 }}>
              {lang === "es" ? "Ya cooperaste" : "You already contributed"} {giftSym}{parseFloat(myCooperation.amount).toFixed(0)} — {lang === "es" ? "esto lo actualizará" : "this will update it"}
            </div>
          )}
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 4 }}>
          <p style={{ fontSize: 11, color: "#aaa", textAlign: "center", margin: "4px 0" }}>
            {lang === "es" ? "Elige cómo pagar — la app registrará tu cooperación al regresar" : lang === "fi" ? "Valitse maksutapa — sovellus kirjaa panoksesi palattuasi" : "Choose how to pay — the app will register your contribution when you return"}
          </p>

          {hasMp ? (
            <a
              href={(function() {
                const mp = (owner.mercadopago || "").trim();
                if (!mp) return "#";
                if (mp.startsWith("http://") || mp.startsWith("https://")) return mp;
                return "https://" + mp;
              })()}
              target="_blank" rel="noopener noreferrer"
              style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, background: "#00b1ea", color: "#fff", borderRadius: 12, padding: "12px 16px", fontWeight: 600, fontSize: 14, textDecoration: "none" }}
              onClick={function(e) {
                if (!cooperateAmount || isNaN(parseFloat(cooperateAmount))) { e.preventDefault(); showToast(lang === "es" ? "Ingresa un monto primero" : "Enter an amount first"); return; }
                cooperateGift(cooperateModal.wishlistId, g.id, cooperateAmount, "mercadopago");
                close();
              }}>
              💳 MercadoPago
            </a>
          ) : (
            <button style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, background: darkMode ? "#1a3a45" : "#e8f7fd", color: "#00b1ea", borderRadius: 12, padding: "12px 16px", fontWeight: 600, fontSize: 14, border: "1.5px solid #00b1ea", cursor: "pointer" }}
              onClick={function() { setCooperatePayError("mp"); }}>
              💳 MercadoPago
            </button>
          )}

          {hasPp ? (
            <a href={owner.paypal} target="_blank" rel="noopener noreferrer"
              style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, background: "#003087", color: "#fff", borderRadius: 12, padding: "12px 16px", fontWeight: 600, fontSize: 14, textDecoration: "none" }}
              onClick={function(e) {
                if (!cooperateAmount || isNaN(parseFloat(cooperateAmount))) { e.preventDefault(); showToast(lang === "es" ? "Ingresa un monto primero" : "Enter an amount first"); return; }
                cooperateGift(cooperateModal.wishlistId, g.id, cooperateAmount, "paypal");
                close();
              }}>
              🅿️ PayPal
            </a>
          ) : (
            <button style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, background: darkMode ? "#0a0f20" : "#eef2fb", color: "#003087", borderRadius: 12, padding: "12px 16px", fontWeight: 600, fontSize: 14, border: "1.5px solid #003087", cursor: "pointer" }}
              onClick={function() { setCooperatePayError("pp"); }}>
              🅿️ PayPal
            </button>
          )}

          {cooperatePayError && (
            <div style={{ background: darkMode ? "#2a2a2a" : "#fff8f0", border: "1px solid #d4a853", borderRadius: 12, padding: "12px 14px", textAlign: "center" }}>
              <p style={{ fontSize: 13, color: darkMode ? "#e8e2d9" : "#1a1a1a", marginBottom: 10 }}>
                {lang === "es" ? "Esta persona no ha agregado su método de pago" : "This person hasn't added their payment method"}
              </p>
              
            </div>
          )}
        </div>

        <div style={{ display: "flex", gap: 8, marginTop: 14 }}>
          <button className="btn btn-dorado" style={{ flex: 2 }} onClick={doCooperate}>
            {lang === "es" ? "✓ Aceptar" : lang === "fi" ? "✓ Hyväksy" : "✓ Accept"}
          </button>
          <button className="btn btn-gris" style={{ flex: 1 }} onClick={close}>
            {lang === "es" ? "Cancelar" : "Cancel"}
          </button>
        </div>
      </div>
    </div>
  );
}
